import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
// @ts-expect-error - no TypeScript definitions yet
import { ErrorMessage } from 'src/components/ErrorMessage';
import { Loader } from 'src/components/Loader';
import { isInIframe } from 'src/lib/browser';
import { createStateSelectorHook } from 'src/lib/sweetState';

import { ConsentLayout } from './components/ConsentLayout';
import { MainStore } from './store/main';
import { ViewClientConsent } from './views/ViewClientConsent';
import { ViewCopilotConsent } from './views/ViewCopilotConsent';
import styles from './View.module.scss';

const useRequestState = createStateSelectorHook(MainStore, [
  'loading',
  'errorMessage',
  'consentRequest',
]);

export const View = () => {
  const { loading, errorMessage, consentRequest } = useRequestState();

  if (loading) {
    return (
      <ConsentLayout>
        <Loader data-testid="oauthConsentLoader" />
      </ConsentLayout>
    );
  }

  if (!consentRequest) {
    return (
      <ConsentLayout>
        <ErrorMessage
          className={styles.message}
          error={errorMessage}
          data-testid="oauthConsentError"
        />
      </ConsentLayout>
    );
  }

  if (consentRequest.trusted) {
    return <ViewCopilotConsent />;
  }

  // Another site could frame the page and trick the user into a click on Authorize.
  if (isInIframe()) {
    return (
      <ConsentLayout>
        <CustomTypography
          className={styles.message}
          variant={TYPOGRAPHY_VARIANT.regular14}
          data-testid="oauthConsentFrameRefusal"
        >
          Open this page in its own browser window to connect your AI tool.
        </CustomTypography>
      </ConsentLayout>
    );
  }

  return <ViewClientConsent consentRequest={consentRequest} />;
};
